// extracted by mini-css-extract-plugin
export var printerCard = "_b8-1";
export var printerCardConfigured = "_b8-2";
export var printerCardError = "_b8-3";
export var printerCardsContainer = "_b8-0";
export var printerIcon = "_b8-8";
export var printerIconConfigured = "_b8-5";
export var printerIconContainer = "_b8-4";
export var printerIconError = "_b8-6";
export var printerIconUnconfigured = "_b8-7";